const TABLET_UA_REGEXP = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i;
const ANDROID_UA_REGEXP = /Android/i;
const SAFARI_UA_REGEXP = /^((?!chrome|android).)*safari/i;

const isTablet = (): boolean => {
    if (window.orientation !== undefined) {
        return true;
    }

    return navigator.userAgent.match(TABLET_UA_REGEXP) !== null;
};

export const SIZE = { XS: 'xs', SM: 'sm', MD: 'md', LG: 'lg' };

export class SizeHelper {
    isMobile: boolean;

    isTablet: boolean;

    size: string;

    isAndroid: boolean;

    isSafari: boolean;

    isRetina: boolean;

    constructor(size?: string) {
        this.size = size || SIZE.MD;
        this.isMobile = false;
        this.isTablet = isTablet();
        this.isSafari = SAFARI_UA_REGEXP.test(navigator.userAgent);
        this.isAndroid = ANDROID_UA_REGEXP.test(navigator.userAgent);
        this.isRetina = false;
    }
}
